import {useConstants} from "./useConstants";

export const useEnableExperimentalFeatures = (): boolean => useConstants().EnableExperimentalFeatures;
